var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    [
      _c(
        "v-layout",
        { staticStyle: { width: "70%" }, attrs: { row: "", wrap: "" } },
        [
          _vm._l(_vm.characters, function(characterEle, index) {
            return _c(
              "v-flex",
              { key: index, staticStyle: { "max-width": "27%" } },
              [
                _c(
                  "v-chip",
                  {
                    attrs: { color: characterEle.color },
                    on: {
                      click: function($event) {
                        return _vm.add(
                          characterEle.value,
                          characterEle.color,
                          characterEle.id
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(characterEle.value))]
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.characters.length !== 0
            ? _c("v-checkbox", {
                staticStyle: { "margin-top": "4px" },
                attrs: { label: "Trigger" },
                model: {
                  value: _vm.trigger,
                  callback: function($$v) {
                    _vm.trigger = $$v
                  },
                  expression: "trigger"
                }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "white" } },
        [
          _c(
            "v-flex",
            { staticStyle: { border: "solid silver 2px" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _vm.leftCharacterName
                    ? _c(
                        "v-chip",
                        {
                          staticStyle: { height: "50%" },
                          attrs: {
                            color: _vm.leftCharacterName.characterColor
                          },
                          on: { click: _vm.removeLeft }
                        },
                        [_vm._v(_vm._s(_vm.leftCharacterName.characterName))]
                      )
                    : _c("v-chip", { staticStyle: { height: "50%" } }, [
                        _vm._v(_vm._s(_vm.leftCharacterName))
                      ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "margin-top": "9px" } }, [
                    _vm._v(" to ")
                  ]),
                  _vm._v(" "),
                  _vm.rightCharacterName
                    ? _c(
                        "v-chip",
                        {
                          staticStyle: { height: "50%" },
                          attrs: {
                            color: _vm.rightCharacterName.characterColor
                          },
                          on: { click: _vm.removeRight }
                        },
                        [_vm._v(_vm._s(_vm.rightCharacterName.characterName))]
                      )
                    : _c("v-chip", { staticStyle: { height: "50%" } }, [
                        _vm._v(_vm._s(_vm.rightCharacterName))
                      ]),
                  _vm._v(" "),
                  _c("v-text-field", {
                    staticStyle: {
                      "padding-top": "0px",
                      "margin-top": "0px",
                      "margin-bottom": "0px",
                      "max-width": "85%"
                    },
                    attrs: { label: "says:", "single-line": "" },
                    model: {
                      value: _vm.currentLine,
                      callback: function($$v) {
                        _vm.currentLine = $$v
                      },
                      expression: "currentLine"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticStyle: { right: "2px", top: "10px" },
                      attrs: { absolute: "" },
                      on: { click: _vm.enter }
                    },
                    [_vm._v("Enter")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.warn !== ""
            ? _c("span", { staticStyle: { color: "red" } }, [
                _vm._v(_vm._s(_vm.warn))
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a461aa5", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a461aa5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-edit-view/conversation/bottomBlock.vue
// module id = null
// module chunks = 